 <template>
  <!-- 画布元素-->
  <div id="canvas"></div>
</template>
<script>
import * as THREE from "three"; //3D基础类
//import { OBJLoader } from "three/examples/jsm/loaders/OBJLoader"; //导入外部辅组obj模型类
import { OBJLoader, MTLLoader } from "three-obj-mtl-loader";
//xyz对应的坐标轴  红绿蓝 rgb
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls"; //轨道控制器  随着随便放大 缩小

export default {
  //变量申明模块
  data() {
    return {
      renderer: null, //渲染器
      // loader, //纹理加载器
      scene: null, //场景
      camera: null, //相机
      controls: null, //轨道控制器
      mesh: null, //网格
      meshgroup: null,
      clock: null, //时钟对象 轨迹运动
      mixer: null, //轨迹运动对象
    };
  },
  //方法申明模块
  methods: {
    init: function () {
      this.renderer = new THREE.WebGLRenderer({
        //增加下面两个属性，可以抗锯齿
        antialias: true,
        alpha: true,
      });
      /*-- 设置渲染器背景颜色--*/
      //renderer.setClearColor("rgb(135,206,250)", 1.0);
      // this.renderer.setClearColor("rgb(241,243,241)", 1.0);
      //设置渲染器高度与宽度
      this.renderer.setSize(window.innerWidth, window.innerHeight);
      this.renderer.setClearAlpha(0.01);
      //告诉渲染器我需要阴影
      this.renderer.shadowMap.enabled = true;
      //渲染器加入到网页BODY里面去
      //  document.body.appendChild(this.renderer.domElement);

      let container = document.getElementById("canvas");
      container.appendChild(this.renderer.domElement);
      //场景
      this.scene = new THREE.Scene();
      let loader = new THREE.TextureLoader();
      let bgTexture = loader.load("/comom/bluebg1.png");

      this.scene.background = bgTexture;

      //相机
      this.camera = new THREE.PerspectiveCamera(
        75,
        window.innerWidth / window.innerHeight,
        0.1,
        1000
      );
      //相机的位置
      this.camera.position.x = 0;
      //设置相机的高度
      this.camera.position.y = 2.7795;
      //设置相机的相对于看到的距离
      this.camera.position.z = 10;
      //实例化轨道控制器 必须实例化在 相机和渲染器后面
      this.controls = new OrbitControls(this.camera, this.renderer.domElement);

      // 创建一个矩形平面几何体，宽度100，长度200
      var plane = new THREE.PlaneGeometry(11, 11);

      let texturefloor = loader.load("/MaterialRack/floor.jpg");

      var materialplan = new THREE.MeshPhongMaterial({
        // 矩形平面网格模型默认单面显示，可以设置side属性值为THREE.DoubleSide双面显示
        side: THREE.DoubleSide,
        map: texturefloor,
      });
      //平面出来 默认是水平面 需要向X轴 旋转弧度
      plane.rotateX(-1.570796);
      //（4）最后告诉最底下的平面长方形你要接受阴影：
      plane.receiveShadow = true;

      this.mesh = new THREE.Mesh(plane, materialplan);
      this.scene.add(this.mesh);
      //加入光源
      var pointLight = new THREE.PointLight("#ffffff");
      //光源坐标
      pointLight.position.set(0, 10, 10);
      //2、告诉灯光，我需要阴影：
      pointLight.castShadow = true;

      this.scene.add(pointLight);
      //实例化一个正方体盒子  长宽高
      const geometry = new THREE.BoxGeometry(0.5, 0.3, 0.5);
      const textTureLoader = new THREE.TextureLoader();
      const textTure = textTureLoader.load("/MaterialRack/box2.jpg");
      //设置盒子纹理
      const material = new THREE.MeshBasicMaterial({ map: textTure });

      //将盒子与纹理加入网格模型对象
      const cube = new THREE.Mesh(geometry, material);
      cube.position.set(4, 0.1, -3.3); //设置mesh3模型对象的xyz坐标为
      cube.scale.set(0.5, 0.5, 0.5);
      //cube.translateX(120)
      cube.castShadow = true;
      //将网格加入画布
      this.scene.add(cube);

      //加入另外一种盒子
      const texture1 = textTureLoader.load("/MaterialRack/box.jpg");
      //设置盒子纹理
      const material1 = new THREE.MeshBasicMaterial({ map: texture1 });
      const cube1 = new THREE.Mesh(geometry, material1);
      cube1.position.set(5, 0.1, -3.3); //设置mesh3模型对象的xyz坐标为
      cube1.scale.set(0.5, 0.5, 0.5);
      //cube.translateX(120)
      cube1.castShadow = true;
      //将网格加入画布
      this.scene.add(cube1);

      //加入另外一种盒子
      const texture2 = textTureLoader.load("/MaterialRack/boxTexture.jpg");
      //设置盒子纹理
      const material2 = new THREE.MeshBasicMaterial({ map: texture2 });
      const cube2 = new THREE.Mesh(geometry, material2);
      cube2.position.set(5, 0.1, -2.3); //设置mesh3模型对象的xyz坐标为
      cube2.scale.set(0.5, 0.5, 0.5);
      //cube.translateX(120)
      cube2.castShadow = true;
      //将网格加入画布
      this.scene.add(cube2);

      //轨迹运动
      {
        // 通过类CatmullRomCurve3创建一个3D样条曲线
        //
        var curve = new THREE.CatmullRomCurve3([
          new THREE.Vector3(4, 0.1, -3.3),
          new THREE.Vector3(4.1, 0.1, -2.3),
          new THREE.Vector3(4.2, 0.1, -1.3),
          new THREE.Vector3(4.7, 0.1, -0.3),
          new THREE.Vector3(4, 0.1, 0.7),
          new THREE.Vector3(3.8, 0.1, 1.7),
          new THREE.Vector3(4.3, 0.1, 2.7),
        ]);
        // 样条曲线均匀分割100分，返回51个顶点坐标
        var points = curve.getPoints(100);
        //console.log("points", points); //控制台查看返回的顶点坐标
        var geometry1 = new THREE.BufferGeometry();
        // 把从曲线轨迹上获得的顶点坐标赋值给几何体
        geometry1.setFromPoints(points);
        var materialx1 = new THREE.LineBasicMaterial({
          color: 0x4488ff,
        });
        var line = new THREE.Line(geometry1, materialx1);
        this.scene.add(line);

        // 通过Threejs的帧动画相关API播放网格模型沿着曲线做动画运动

        // 声明一个数组用于存储时间序列
        let arr = [];
        for (let i = 0; i < 101; i++) {
          arr.push(i);
        }
        // 生成一个时间序列
        var times = new Float32Array(arr);

        var posArr = [];
        points.forEach((elem) => {
          posArr.push(elem.x, elem.y, elem.z);
        });
        // 创建一个和时间序列相对应的位置坐标系列
        var values = new Float32Array(posArr);
        // 创建一个帧动画的关键帧数据，曲线上的位置序列对应一个时间序列
        var posTrack = new THREE.KeyframeTrack(".position", times, values);
        let duration = 101;
        let clip = new THREE.AnimationClip("default", duration, [posTrack]);

        //设置要运动的物体对象
        this.mixer = new THREE.AnimationMixer(cube);
        let AnimationAction = this.mixer.clipAction(clip);
        AnimationAction.timeScale = 20;
        AnimationAction.play();
      }
      // 辅助坐标系  参数200表示坐标系大小，可以根据场景大小去设置
      // var axesHelper = new THREE.AxesHelper(200);
      // this.scene.add(axesHelper);
      //必须在对相机的变换进行任何手动更改后调用
      this.controls.update();
      //console.log("1");
      //申明总的总标点位
      var totalboxs = 5 * 13 * 9;
      var positions = [totalboxs];
      //obj导入类
      var mtlLoader = new MTLLoader();
      mtlLoader.load("/MaterialRack/rack-2.mtl", function (materials) {
        materials.preload();
        var objloader = new OBJLoader();
        objloader.setMaterials(materials);
        objloader.load("/MaterialRack/rack-2.obj", function (object) {
          var rowposY = 0;
          var cellposz = -2.888;
          var totalRowx = -3.088;

          var t_racktotalRow = 5;
          var t_rackCell = 13;
          var t_racksingleRow = 9;
          //缩放比列
          object.scale.set(0.4, 0.4, 0.2);

          var i = 0;
          //平面总共有多少排 循环排数
          for (
            var i_racktotalRow = 0;
            i_racktotalRow <= t_racktotalRow;
            i_racktotalRow++
          ) {
            //单排有多少列  循环列数
            for (var i_rackCell = 0; i_rackCell <= t_rackCell; i_rackCell++) {
              //单列有多少层  循环层数
              for (
                var i_racksingleRow = 0;
                i_racksingleRow <= t_racksingleRow;
                i_racksingleRow++
              ) {
                //模型的x、y、z轴的位置
                object.position.set(totalRowx, rowposY, cellposz);
                object.castShadow = true;
                var newrack = object.clone();
                //（3）告诉模型哪些需要投射阴影：

                // this.scene.add(newrack);
                window.that.scene.add(newrack);
                positions[i] = [totalRowx, rowposY, cellposz];
                //console.log(positions[i]);
                i += 1;
                //层间距
                rowposY += 0.4;
              }

              //单排列间距
              cellposz += 0.5355;
              rowposY = 0;
            }
            //排间距
            totalRowx += 1.303;
            cellposz = -2.888;
          }

          //根据点位 把箱子加载进去
          var boxid = 0;
          for (var p = 0; p < positions.length; p++) {
            boxid += 1;

            var randNum = Math.round(Math.random() * 2); // 生成0~1的随机整数
            var newcube = null;
            if (randNum == 0) {
              newcube = cube.clone();
            } else if (randNum == 1) {
              newcube = cube1.clone();
            } else {
              newcube = cube2.clone();
            }

            newcube.scale.set(0.7, 1, 0.7);
            newcube.ID = boxid;
            var element = positions[p];
            newcube.position.set(element[0], element[1] + 0.2232, element[2]); //设置mesh3模型对象的xyz坐标为
            //将网格加入画布
            // this.scene.add(newcube);
            window.that.scene.add(newcube);
          }
        });
      });
      this.clock = new THREE.Clock(); //声明一个时钟对象 轨迹运动
    },
    createFonts: function () {
      var textLoad = new THREE.FontLoader();
      //加载字体JSON http://gero3.github.io/facetype.js/
      textLoad.load("/fonts/STXingkai_Regular.json", function (font) {
        var txtGeo = new THREE.TextGeometry("A-2", {
          font: font,
          size: 0.7,
          height: 0.1,
          curveSegments: 12,
          bevelEnabled: true,
          bevelThickness: 0.1,
          bevelSize: 0.05,
          bevelSegments: 3,
        });

        var txtMater = new THREE.MeshBasicMaterial({ color: 0x0000ff });
        var txtMesh = new THREE.Mesh(txtGeo, txtMater);
        txtMesh.position.set(5, 0.7, -3.3);
        window.that.scene.add(txtMesh);
      });
    },
    dramLine: function () {
      //create a blue LineBasicMaterial 创建线的材质
      const materialLine = new THREE.LineBasicMaterial({ color: 0x0000ff });

      //定义点位
      const points = [];
      points.push(new THREE.Vector3(5, 0.3, -3.3));
      points.push(new THREE.Vector3(5, 0.6, -3.3));
      points.push(new THREE.Vector3(5, 0.9, -3.3));
      //定义好材质之后，我们需要一个带有一些顶点的geometry（几何体）。
      const geometry = new THREE.BufferGeometry().setFromPoints(points);

      const line = new THREE.Line(geometry, materialLine);
      this.scene.add(line);
      this.renderer.render(this.scene, this.camera);
    },

    animate: function () {
      requestAnimationFrame(this.animate);

      //如果controls.enableDamping 或controls.autoRotate 设置为true，则需要
      // this.controls.update();
      this.controls.update();
      this.renderer.render(this.scene, this.camera);
      //旋转场景
      this.scene.rotation.y += 0.0011;

      // cube1.rotation.x += 0.01;
      //  cube2.rotation.x += 0.01;
      // cube.rotation.y += 0.01;

      // 更新帧动画的时间 轨迹运动
      this.mixer.update(this.clock.getDelta());
    },
    onWindowResize: function () {
      this.renderer.setSize(window.innerWidth, window.innerHeight);
    },
  },
  //模板渲染成html后调用，通常是初始化页面完成后，再对html的dom节点进行一些需要的操作
  mounted() {
    window.that = this;
    this.init();
    //创建字体
    //  this.createFonts();
    this.animate();
    //画线
    this.dramLine();

    window.addEventListener("resize", () => this.onWindowResize(), false);
  },
};

// this.scene.rotateY(-1.570796326794896619);
</script>

